"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Person_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Person = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const foaf_1 = require("../ontologies/foaf");
const Gravatar_1 = require("../utils/Gravatar");
let Person = Person_1 = class Person extends Shape_1.Shape {
    /**
     * instances of this shape need to have exactly one value defined for the given property
     */
    get name() {
        return this.hasProperty(foaf_1.foaf.name) ? this.getValue(foaf_1.foaf.name) : '';
    }
    set name(val) {
        this.overwrite(foaf_1.foaf.name, new models_1.Literal(val));
    }
    /**
     * instances of this shape need to have exactly one value defined for the given property
     */
    get depiction() {
        return this.getOne(foaf_1.foaf.depiction);
    }
    set depiction(val) {
        this.overwrite(foaf_1.foaf.depiction, val);
    }
    get img() {
        return this.getOne(foaf_1.foaf.img);
    }
    set img(val) {
        this.overwrite(foaf_1.foaf.img, val);
    }
    /**
     * instances of this shape need to have exactly one value defined for the given property
     */
    get homepage() {
        return this.getOne(foaf_1.foaf.homepage);
    }
    set homepage(homepage) {
        this.overwrite(foaf_1.foaf.homepage, homepage);
    }
    /**
     * instances of this shape need to have exactly one value defined for the given property
     */
    get workplaceHomepage() {
        return this.getOne(foaf_1.foaf.workplaceHomepage);
    }
    set workplaceHomepage(workplaceHomepage) {
        this.overwrite(foaf_1.foaf.workplaceHomepage, workplaceHomepage);
    }
    get basedNear() {
        return this.getOne(foaf_1.foaf.based_near);
    }
    set basedNear(place) {
        this.overwrite(foaf_1.foaf.based_near, place);
    }
    //@TODO: use inversePath & regex for an Email/Mailbox NodeShape, to indicate that each email can only be owned by 1 person
    // then also remove the (wrong) maxCount 1.
    /**
     * A persons personal mailbox.
     */
    get email() {
        var _a;
        return (_a = this.getOne(foaf_1.foaf.mbox)) === null || _a === void 0 ? void 0 : _a.uri.replace('mailto:', '');
    }
    set email(val) {
        this.overwrite(foaf_1.foaf.mbox, models_1.NamedNode.getOrCreate('mailto:' + val));
    }
    get knows() {
        return this.getAllAs(foaf_1.foaf.knows, Person_1);
    }
    static isImage(url) {
        return /^https?:\/\/.+\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
    }
    /**
     * Try to obtain a profiles picture of this person based on their depiction, img, homepage or email (gravatar)
     * @param imageRequestSize
     */
    //@TODO: add decorators here for methods that indicate which properties they need
    //so that the method gets connected to a node shape or property shape
    //in this case a node shape with several property shapes
    getProfilePicture(imageRequestSize) {
        if (this.depiction && Person_1.isImage(this.depiction)) {
            return this.depiction.uri;
        }
        else if (this.img && Person_1.isImage(this.img)) {
            return this.img.uri;
        }
        else if (this.homepage &&
            this.homepage.uri.indexOf('github.com') !== -1) {
            //find picture from GitHub
            //https://stackoverflow.com/a/36380674/977206
            return this.homepage + '.png?size=' + imageRequestSize;
        }
        else if (this.email) {
            //try gravatar
            return (0, Gravatar_1.getGravatarFromEmail)(this.email, imageRequestSize);
        }
    }
};
exports.Person = Person;
/**
 * indicates that instances of this shape need to have this rdf.type
 */
Person.targetClass = foaf_1.foaf.Person;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: foaf_1.foaf.name,
        required: true,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "name", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: foaf_1.foaf.depiction,
        maxCount: 1,
    }),
    __metadata("design:type", models_1.NamedNode),
    __metadata("design:paramtypes", [models_1.NamedNode])
], Person.prototype, "depiction", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: foaf_1.foaf.img,
        maxCount: 1,
    }),
    __metadata("design:type", models_1.NamedNode),
    __metadata("design:paramtypes", [models_1.NamedNode])
], Person.prototype, "img", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: foaf_1.foaf.homepage,
        maxCount: 1,
    }),
    __metadata("design:type", models_1.NamedNode),
    __metadata("design:paramtypes", [models_1.NamedNode])
], Person.prototype, "homepage", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: foaf_1.foaf.workplaceHomepage,
        maxCount: 1,
    }),
    __metadata("design:type", models_1.NamedNode),
    __metadata("design:paramtypes", [models_1.NamedNode])
], Person.prototype, "workplaceHomepage", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: foaf_1.foaf.based_near,
        maxCount: 1,
    }),
    __metadata("design:type", models_1.NamedNode),
    __metadata("design:paramtypes", [models_1.NamedNode])
], Person.prototype, "basedNear", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: foaf_1.foaf.mbox,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "email", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: foaf_1.foaf.knows,
        shape: Person,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "knows", null);
exports.Person = Person = Person_1 = __decorate([
    package_1.linkedShape
], Person);
//# sourceMappingURL=Person.js.map